import React, { PropTypes, Component } from 'react';

import Container from '../../components/layouts/Container';
import Page from '../../components/layouts/Page';

class FleetPageLayout extends Component {
  render() {
    return (
      <Container>
        <Page header>
          {this.props.children}
        </Page>
      </Container>
    );
  }
}

FleetPageLayout.propTypes = {
  children: PropTypes.object
};

export default FleetPageLayout;



// WEBPACK FOOTER //
// ./src/layouts/fleet/FleetPageLayout.js